<script lang="ts">
    export let banner: { src: string; alt: string } | null;
    export let mobileBanner: { src: string; alt: string } | null;
    export let borderRadius = "16px";
    export let heightXs: string | null = "250px";
    export let heightSm: string | null = "300px";
    export let heightMd: string | null = "400px";
    export let heightLg: string | null = "500px";
    let _class = "";
    export { _class as class };
    
    $: mobileDisplayBanner = mobileBanner || banner;
</script>

{#if banner || mobileBanner}
    <div class="banner-wrapper {_class}" 
        style="
            --banner-height-xs: {heightXs || '250px'};
            --banner-height-sm: {heightSm || '300px'};
            --banner-height-md: {heightMd || '400px'};
            --banner-height-lg: {heightLg || '500px'};
        ">
        {#if banner}
            <img src={banner.src} alt={banner.alt} class="subpage-banner desktop-banner" style="border-radius: {borderRadius}" />
        {/if}
        
        {#if mobileDisplayBanner}
            <img src={mobileDisplayBanner.src} alt={mobileDisplayBanner.alt} class="subpage-banner mobile-banner" style="border-radius: {borderRadius}" />
        {/if}
    </div>
{/if}

<style lang="scss">
    .banner-wrapper {
        width: 100%;
        margin: 0 auto;
        position: relative;
    }

    .subpage-banner {
        width: 100%;
        object-fit: cover;
        object-position: center center;
    }

    .desktop-banner {
        display: none;
        
        @media (min-width: 769px) {
            display: block;
            max-height: var(--banner-height-lg);
        }
    }

    .mobile-banner {
        display: block;
        
        @media (max-width: 320px) {
            max-height: var(--banner-height-xs);
        }
        
        @media (min-width: 321px) and (max-width: 576px) {
            max-height: var(--banner-height-sm);
        }
        
        @media (min-width: 577px) and (max-width: 768px) {
            max-height: var(--banner-height-md);
        }
        
        @media (min-width: 769px) {
            display: none;
        }
    }
</style> 